import React from 'react';
import './preview.css';

function Preview({ content = '', images = [], printRef }) {
    return (
        <div ref={printRef} className="preview_container" style={{ background: '#ffffff', padding: '16px' }}>
            <div dangerouslySetInnerHTML={{ __html: content }} />

            {images.length > 0 && (
                <div className="preview_images_grid" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
                    {images.map((imgUrl, index) => (
                        <img
                            key={index}
                            src={imgUrl}
                            alt={'image' + index}
                            style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '4px' }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default Preview;